import React from 'react';
import * as modalWindowActions from 'root/modal/modalWindowActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { ModalEnum } from 'myParkdUtils/enums';
import { CONTENT_REPORT_A_BUG_TO_SUPPORT_MODAL } from 'myParkdUtils/basicMessageModalContent';

const SomethingWentWrongModal = props => (
    <div className="panel radius-rectangle full-width-form">
        <div className="panel-header center">
            <h2 className="bold-title">
                <FontAwesomeIcon icon={faExclamationTriangle} className="fa-icon" />
                <FormattedMessage id="FEEDBACK_SOMETHING_WENT_WRONG_TITLE" />
            </h2>
            <button className="btn-close-modal" onClick={props.closeModal} />
        </div>
        <div className="panel-content">
            <p className="align-left">
                <FormattedMessage id="FEEDBACK_SOMETHING_WENT_WRONG_TEXT" />
            </p>
            <div className="row-7">
                <div className="col-6">
                    <button
                        className="btn-red"
                        onClick={() =>
                            props.updateModal(ModalEnum.SEND_MESSAGE_TO_SUPPORT, {
                                modalContent: CONTENT_REPORT_A_BUG_TO_SUPPORT_MODAL
                            })
                        }
                    >
                        <FormattedMessage id="REPORT_A_BUG" />
                    </button>
                </div>
                <div className="col-6">
                    <button className="btn-blue" onClick={props.closeModal}>
                        <FormattedMessage id="GLOBAL_CLOSE" />
                    </button>
                </div>
            </div>
        </div>
    </div>
);

function mapStateToProps(state, props) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            updateModal: modalWindowActions.updateModalWindow
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(SomethingWentWrongModal);
